// Production Status (PSR) — 70_ProductionStatus.jsx, 2026-11-03 (Jay 01/11). Order codes, PO numbers, EXF, PPS, PPM, IQC, C/O stay as written.
const en = {
  tourTodoT: "What waits on you",
  tourTodoB: "Steps whose plan date has passed without an actual date, HEVN changes you have not answered, and EXF dates you have not confirmed yet. Click one to see those rows.",
  tourFindT: "Find your rows",
  tourFindB: "Search by order no., PO, item or colour, and click a status to see only those rows. Every column header sorts and filters like Excel.",
  tourOpenT: "Update one order",
  tourOpenB: "Open shows the order: confirm the EXF, fill in the plan and actual date of each of the 12 steps, and read its history. An actual date cannot be in the future.",
  tourBulkT: "Update many at once",
  tourBulkB: "Tick rows (or all of them here) to set the same plan date, actual date or N/A on one step for all of them, or to confirm their required EXF.",
  tourExcelT: "Work in Excel",
  tourExcelB: "Download the rows on screen, fill in the dates in Excel (dd/Mon/yyyy, e.g. 05/Nov/2026) and upload the file. You see what will change before anything is saved; a blank cell changes nothing.",
  tourCalT: "Ship calendar",
  tourCalB: "The shipment plan by month: each order on its Required EXF (or its Confirmed EXF). Tick vendors and holiday countries, switch the chips between status and vendor, and click a day, chip or week number to list its orders. \"!\" = the date has passed and it has not shipped.",
  tourChangesT: "HEVN changes",
  tourChangesB: "When HEVN changes an EXF date or a quantity, it waits here: acknowledge it, or suggest another date for HEVN to accept.",
  tourSyncT: "Sync from Master",
  tourSyncB: "The rows come from the Master Sheet after each ledger refresh (05:30 and 13:30). Sync now reads it straight away; it takes about a minute.",
  tabCal: "Ship calendar",
  calPrev: "Previous month",
  calNext: "Next month",
  calBasis: "Date basis",
  calBasis_req: "Required EXF",
  calBasis_cfm: "Confirmed EXF",
  calView: "Chips",
  calViewStatus: "All · by status",
  calViewVendor: "By vendor",
  calVendors: "Vendors",
  calAll: "All",
  calNone: "None",
  calHolidays: "Holidays",
  calS_late: "Late",
  calS_noactual: "No actual",
  calS_noinput: "No input",
  calS_ontrack: "On track",
  calS_shipped: "Shipped",
  calMonthSum: "{{n}} order(s) · {{qty}} pcs this month",
  calMore: "{{n}} more",
  calLate: "{{n}} late",
  calPastMark: "Not shipped and the date has passed",
  calPastBtn: "Past EXF, not shipped ({{n}})",
  calListDay: "{{d}} — {{n}} order(s), {{qty}} pcs",
  calListWeek: "Week {{w}} — {{n}} order(s), {{qty}} pcs",
  calListPast: "Past EXF date and not shipped — {{n}} order(s), {{qty}} pcs",
  calEmpty: "No orders here.",
  calWeek: "Week {{w}}",
  calFallback: "Rows without a Confirmed EXF stay on their Required EXF.",
  calHolidayFail: "Could not read the {{c}} holidays from Google just now.",
  calCountry_VN: "Vietnam",
  calCountry_KR: "Korea",
  calCountry_US: "USA",
  calCountry_NL: "Netherlands",
  calCountry_SG: "Singapore",
  calCountry_JP: "Japan",
  xlDown: "Download Excel",
  xlUp: "Upload Excel",
  xlReading: "Reading the file…",
  xlPreview: "What the file changes",
  xlSummary: "{{ok}} row(s) will change, {{failed}} with a problem, {{unchanged}} unchanged. Blank cells change nothing.",
  xlApply: "Apply the changes",
  xlApplied: "{{ok}} row(s) updated from the file, {{failed}} not.",
  xlRow: "Row",
  xlRowId: "Row ID",
  nav: "Production Status",
  title: "Production Status",
  sub: "Rows come from the Master Sheet; vendors update progress, HEVN sees every vendor. Prices are never shown here.",
  subVendor: "Your open orders from Helinox. Update progress here — no Excel file is needed any more.",
  vendor: "Vendor",
  allVendors: "All vendors",
  sync: "Sync from Master",
  syncing: "Syncing… (about a minute)",
  lastSync: "Last sync {{when}}",
  synced: "Synced: {{created}} new rows, {{changed}} changed by HEVN, {{closed}} closed.",
  tabRows: "Orders",
  tabChanges: "Changes",
  todoTitle: "This week's to-do",
  todoActual: "{{n}} actual date(s) missing",
  todoChanges: "{{n}} HEVN change(s) to acknowledge",
  todoCfm: "{{n}} order(s) without your Confirmed EXF",
  search: "Search order, PO, item, colour…",
  clearFilters: "Clear filters",
  shownOf: "{{n}} of {{m}}",
  colStatus: "Status",
  colLot: "Order",
  colItem: "Item",
  colQty: "Qty",
  colReq: "Req. EXF",
  colCfm: "Cfm. EXF",
  colProgress: "Progress",
  colNext: "Next step",
  colUpdated: "Updated",
  colVendor: "Vendor",
  colAction: "Action",
  open: "Open",
  st_on_track: "On track",
  st_late_vendor: "Late · Vendor",
  st_late_dac: "Late · DAC (frame)",
  st_actual_missing: "Actual date missing",
  st_no_input: "No input",
  st_shipped: "Shipped",
  st_closed: "Closed",
  st_cancelled: "Cancelled",
  all: "All",
  changedOnly: "Changed by HEVN",
  selected: "{{n}} selected",
  bulkStep: "Step",
  bulkWhat: "Set",
  bulkActual: "Actual date",
  bulkPlan: "Plan date",
  bulkNa: "Not applicable",
  bulkCfmReq: "Confirmed EXF = Required EXF",
  today: "Today",
  apply: "Apply to selected",
  bulkDone: "{{ok}} updated, {{failed}} not updated.",
  lines: "Master lines",
  linePo: "HNX PO",
  lineCustomerPo: "Customer PO",
  lineDest: "Destination",
  cfmExf: "Confirmed EXF",
  cfmSame: "Same as required",
  cfmNotYet: "not confirmed yet",
  yourOrderNo: "Your order no.",
  remark: "Remark",
  steps: "Progress steps",
  stepPlan: "Plan",
  stepActual: "Actual",
  stepStatus: "Status",
  stepCoRef: "C/O ref.",
  ss_planned: "Planned",
  ss_done: "Done",
  ss_na: "N/A",
  ss_co: "C/O (done under an earlier order)",
  frameDac: "Frame is DAC’s — HEVN updates it.",
  reason: "Reason",
  reasonNeeded: "Changing an actual date entered before the last weekly close (Friday 17:00) needs a reason.",
  save: "Save",
  saving: "Saving…",
  saved: "Saved.",
  close: "Close",
  hevnChanges: "Changed by HEVN — please confirm",
  acknowledge: "Acknowledge",
  suggest: "Suggest another date",
  suggestSend: "Send",
  suggested: "You suggested {{d}} — waiting for HEVN",
  accept: "Accept",
  reject: "Reject",
  fld_req_exf: "EXF date",
  fld_req_qty: "Quantity",
  fld_cancelled: "Line cancelled",
  history: "History",
  noHistory: "No changes yet.",
  afterClose: "edited after weekly close",
  noRows: "No orders match.",
  noChanges: "Nothing waits for an answer.",
  chgWaitVendor: "waiting for the vendor",
  chgWaitPt: "vendor suggested {{d}} — PT to decide",
  loading: "Loading…",
  readOnly: "You can read Production Status; PT updates it.",
  step_rm_order: "RM order",
  step_rm_arrival: "RM arrival",
  step_iqc: "IQC",
  step_frame: "Frame",
  step_pps: "PPS",
  step_ppm: "PPM",
  step_cutting: "Cutting",
  step_print_emb: "Print/Emb",
  step_skin_sewing: "Skin sewing",
  step_case_sewing: "Case sewing",
  step_packing: "Packing",
  step_exf: "Ex-factory",
  lineCount: "{{n}} Master line(s)",
  tabSewing: "Sewing plan",
  tourSewT: "Sewing plan",
  tourSewB: "Every sewing line across your orders (By line), or one row per order with Skin and Case side by side (By order): line, plan and actual dates, output, material ready and the late start reason. Click a row to open the order.",
  sewTitle: "Sewing lines",
  sewHelp: "One row per sewing line. Part: Skin or Case, or Full product when the item is sewn in one piece (e.g. a backpack). Line # comes from the line list (In-house lines and Subcons). The Skin / Case sewing steps above follow these lines.",
  sew_part: "Part",
  sew_lineId: "Line #",
  sew_workers: "Workers",
  sew_planStart: "Plan start",
  sew_planEnd: "Plan end",
  sew_actStart: "Actual start",
  sew_actEnd: "Actual end",
  sew_lateReason: "Late start reason",
  sew_lateNote: "Note",
  part_skin: "Skin",
  part_case: "Case",
  part_full: "Full product",
  sewAdd: "Add sewing line",
  sewRemove: "Remove this line",
  sewNone: "No sewing line yet. Add one row per line and pick Skin, Case or Full product.",
  sewReq: "+ Request a new line or subcon",
  sewReqPt: "+ Add a line or subcon to the list",
  noLineNo: "no line #",
  kind_inhouse: "In-house",
  kind_subcon: "Subcon",
  linePending: "pending approval",
  lineRejected: "rejected",
  lr_material: "Material late",
  lr_frame_dac: "Frame late (DAC)",
  lr_labor: "Labor / capacity",
  lr_hevn_change: "HEVN change",
  lr_quality: "Quality issue",
  lr_other: "Other",
  lrPick: "Pick a reason",
  sewFromLines: "From the sewing lines below",
  sewFullStep: "Sewing (full product)",
  caseNaFull: "N/A — full product",
  outTitle: "Daily output",
  outHelp: "Enter each day's output per line; a whole week at once is fine. The totals become the Skin / Case / Full product output. Future days cannot be entered.",
  outWeek: "Week",
  outAll: "All days",
  outDayTotal: "Day total",
  outPrev: "‹ Previous week",
  outThis: "This week",
  outNext: "Next week ›",
  outCarried: "Output before daily tracking (from the Excel PSR): {{v}}. It is added to the totals.",
  outNeedLine: "Add a sewing line above, then enter the output per day.",
  warnTitle: "Please check (saving is not blocked):",
  wLateReason: "{{line}}: sewing started later than planned, or has not started. Pick a late start reason.",
  wNoLine: "{{part}} sewing has dates but no line #. Vendor Capacity needs it.",
  wDupLine: "{{part}} sewing lists the same line twice.",
  wOutNoStart: "{{line}}: output is entered but there is no actual start date.",
  wOutBefore: "{{line}}: output on {{d}} is before the actual start date.",
  edited: "edited",
  editedTip: "Changed:",
  histOutput: "output {{d}}",
  hist_added: "line added",
  hist_removed: "line removed",
  bulkSew: "Sewing · {{f}}",
  spByLine: "By line",
  spByOrder: "By order",
  spLinesOf: "{{n}} of {{m}} sewing lines",
  spOrdersOf: "{{n}} of {{m}} orders",
  sp_late: "Late (vendor)",
  sp_prog: "In progress",
  sp_planned: "Planned",
  sp_done: "Done",
  sp_none: "No sewing plan",
  spAfter: "Sewing ends after EXF",
  spHelpLine: "One row per sewing line. The vendor, search and status of Orders apply here too. Click a row to open the order.",
  spHelpOrder: "One row per order. Sewing dates show the earliest line; output is the total of all lines. Material ready = IQC passed (RM arrival when IQC is N/A).",
  spLateStart: "Late sewing start",
  spMissing: "Reason missing",
  spStatusOn: "Status: {{s}}",
  colMat: "Material ready",
  colOutput: "Output",
  colExf: "EXF",
  colStyle: "Style name",
  colColor: "Colour",
  colEstSkin: "Est. sewing (Skin)",
  colEstCase: "Est. sewing (Case)",
  colActSkin: "Actual sewing (Skin)",
  colActCase: "Actual sewing (Case)",
  colOutSkin: "Output (Skin)",
  colOutCase: "Output (Case)",
  matPlan: "plan {{d}}",
  notStarted: "not started",
  nLines: "{{n}} lines",
  missing: "Missing",
  afterExfMark: "› EXF",
  na: "N/A",
  spLineList: "Line list",
  linesPendingBanner: "{{n}} line / subcon request(s) wait for HEVN PT.",
  review: "Review",
  llTitle: "Line list — in-house lines and subcons",
  llHelp: "PT keeps this list. A vendor's new entry can be used at once and reads \"pending approval\" until PT approves it. A rejected entry cannot be saved on an order until the order moves to another line.",
  llType: "Type",
  llName: "Name",
  llDetails: "Details",
  llStatus: "Status",
  llUsed: "Open orders",
  llRequested: "Requested by",
  ls_approved: "Approved",
  ls_pending: "Pending approval",
  ls_rejected: "Rejected",
  approve: "Approve",
  llEmpty: "No line in the list yet.",
  llNoPending: "No request waits.",
  llOnlyPending: "Only requests waiting ({{n}})",
  llAdd: "Add a line or subcon",
  llRequest: "Request a new line or subcon",
  lrqHelpPt: "Added to {{v}}'s list and approved at once.",
  lrqHelpVendor: "HEVN PT reviews every new entry. You can use it right away; it reads \"pending approval\" until PT approves.",
  lrqNamePh: "e.g. LINE 13, or the subcon's name",
  lrqCompany: "Company name",
  lrqAddress: "Address",
  lrqSews: "What they sew",
  lrqNoAccount: "Subcons do not get Portal accounts. You enter their progress and output.",
  lrqSend: "Send request",
  lrqAddBtn: "Add",
  lrqSent: "Request sent to HEVN PT. You can use it now.",
  lrqAdded: "Added to the line list.",
};
const ko = {
  tourTodoT: "처리할 일",
  tourTodoB: "계획일이 지났는데 실적일이 없는 단계, 아직 답하지 않은 HEVN 변경, 아직 확정하지 않은 EXF입니다. 누르면 해당 행만 보입니다.",
  tourFindT: "행 찾기",
  tourFindB: "주문번호, PO, 품목, 색상으로 검색하고 상태를 눌러 해당 행만 볼 수 있습니다. 각 열 머리글은 Excel처럼 정렬·필터됩니다.",
  tourOpenT: "주문 하나 수정",
  tourOpenB: "열기를 누르면 주문이 열립니다. EXF를 확정하고 12단계의 계획일·실적일을 입력하며 이력을 볼 수 있습니다. 실적일은 미래 날짜를 쓸 수 없습니다.",
  tourBulkT: "여러 건 한 번에",
  tourBulkB: "행을 체크하면(여기서 전체 선택) 한 단계에 같은 계획일·실적일·해당 없음을 넣거나, 요청 EXF로 확정할 수 있습니다.",
  tourExcelT: "Excel로 작업",
  tourExcelB: "화면의 행을 내려받아 Excel에서 날짜를 입력하고(dd/Mon/yyyy, 예: 05/Nov/2026) 업로드하세요. 저장 전에 바뀔 내용을 먼저 보여 주며, 빈 칸은 아무것도 바꾸지 않습니다.",
  tourCalT: "출고 캘린더",
  tourCalB: "월별 출고 계획: 각 주문을 요청 EXF(또는 확정 EXF)에 표시합니다. 벤더와 공휴일 국가를 선택하고, 칩을 상태별/벤더별로 바꾸고, 날짜·칩·주차를 누르면 주문 목록이 나옵니다. \"!\" = 날짜가 지났는데 미출고.",
  tourChangesT: "HEVN 변경",
  tourChangesB: "HEVN이 EXF나 수량을 바꾸면 여기에 표시됩니다. 확인하거나, 다른 날짜를 제안해 HEVN이 수락하게 하세요.",
  tourSyncT: "Master에서 동기화",
  tourSyncB: "행은 원장 갱신 후(05:30, 13:30) Master Sheet에서 가져옵니다. 지금 동기화를 누르면 바로 읽으며 약 1분 걸립니다.",
  tabCal: "출고 캘린더",
  calPrev: "이전 달",
  calNext: "다음 달",
  calBasis: "기준 날짜",
  calBasis_req: "요청 EXF",
  calBasis_cfm: "확정 EXF",
  calView: "칩",
  calViewStatus: "전체 · 상태별",
  calViewVendor: "벤더별",
  calVendors: "벤더",
  calAll: "전체",
  calNone: "없음",
  calHolidays: "공휴일",
  calS_late: "지연",
  calS_noactual: "실적 없음",
  calS_noinput: "입력 없음",
  calS_ontrack: "정상",
  calS_shipped: "출고 완료",
  calMonthSum: "이번 달 {{n}}건 · {{qty}}pcs",
  calMore: "{{n}}개 더",
  calLate: "지연 {{n}}",
  calPastMark: "날짜가 지났는데 미출고",
  calPastBtn: "EXF 경과·미출고 ({{n}})",
  calListDay: "{{d}} — {{n}}건, {{qty}}pcs",
  calListWeek: "{{w}}주 — {{n}}건, {{qty}}pcs",
  calListPast: "EXF 경과·미출고 — {{n}}건, {{qty}}pcs",
  calEmpty: "해당 주문이 없습니다.",
  calWeek: "{{w}}주",
  calFallback: "확정 EXF가 없는 행은 요청 EXF에 표시됩니다.",
  calHolidayFail: "지금은 Google에서 {{c}} 공휴일을 읽지 못했습니다.",
  calCountry_VN: "베트남",
  calCountry_KR: "한국",
  calCountry_US: "미국",
  calCountry_NL: "네덜란드",
  calCountry_SG: "싱가포르",
  calCountry_JP: "일본",
  xlDown: "Excel 다운로드",
  xlUp: "Excel 업로드",
  xlReading: "파일 읽는 중…",
  xlPreview: "파일 변경 내용",
  xlSummary: "변경 {{ok}}행, 문제 {{failed}}행, 변경 없음 {{unchanged}}행. 빈 칸은 아무것도 바꾸지 않습니다.",
  xlApply: "변경 적용",
  xlApplied: "파일에서 {{ok}}행 수정, {{failed}}행 미수정.",
  xlRow: "행",
  xlRowId: "Row ID",
  nav: "생산 현황",
  title: "생산 현황",
  sub: "행은 Master Sheet에서 생성됩니다. 협력사는 진행 상황을 입력하고 HEVN은 모든 협력사를 봅니다. 가격은 표시되지 않습니다.",
  subVendor: "Helinox의 진행 중 주문입니다. 여기에서 진행 상황을 입력하세요. 더 이상 Excel 파일이 필요 없습니다.",
  vendor: "협력사",
  allVendors: "전체 협력사",
  sync: "Master에서 동기화",
  syncing: "동기화 중… (약 1분)",
  lastSync: "마지막 동기화 {{when}}",
  synced: "동기화 완료: 신규 {{created}}행, HEVN 변경 {{changed}}건, 종료 {{closed}}건.",
  tabRows: "주문",
  tabChanges: "변경 사항",
  todoTitle: "이번 주 할 일",
  todoActual: "실적 날짜 {{n}}건 누락",
  todoChanges: "확인할 HEVN 변경 {{n}}건",
  todoCfm: "확정 EXF 미입력 {{n}}건",
  search: "주문, PO, 품목, 색상 검색…",
  clearFilters: "필터 지우기",
  shownOf: "{{m}}건 중 {{n}}건",
  colStatus: "상태",
  colLot: "주문",
  colItem: "품목",
  colQty: "수량",
  colReq: "요청 EXF",
  colCfm: "확정 EXF",
  colProgress: "진행률",
  colNext: "다음 단계",
  colUpdated: "수정일",
  colVendor: "협력사",
  colAction: "작업",
  open: "열기",
  st_on_track: "정상",
  st_late_vendor: "지연 · 협력사",
  st_late_dac: "지연 · DAC (프레임)",
  st_actual_missing: "실적 날짜 누락",
  st_no_input: "미입력",
  st_shipped: "출고",
  st_closed: "종료",
  st_cancelled: "취소",
  all: "전체",
  changedOnly: "HEVN 변경",
  selected: "{{n}}건 선택",
  bulkStep: "단계",
  bulkWhat: "입력",
  bulkActual: "실적 날짜",
  bulkPlan: "계획 날짜",
  bulkNa: "해당 없음",
  bulkCfmReq: "확정 EXF = 요청 EXF",
  today: "오늘",
  apply: "선택 항목에 적용",
  bulkDone: "{{ok}}건 수정, {{failed}}건 미수정.",
  lines: "Master 라인",
  linePo: "HNX PO",
  lineCustomerPo: "고객 PO",
  lineDest: "도착지",
  cfmExf: "확정 EXF",
  cfmSame: "요청과 동일",
  cfmNotYet: "미확정",
  yourOrderNo: "귀사 주문번호",
  remark: "비고",
  steps: "진행 단계",
  stepPlan: "계획",
  stepActual: "실적",
  stepStatus: "상태",
  stepCoRef: "C/O 참조",
  ss_planned: "계획",
  ss_done: "완료",
  ss_na: "해당 없음",
  ss_co: "C/O (이전 주문으로 완료)",
  frameDac: "프레임은 DAC 담당이며 HEVN이 입력합니다.",
  reason: "사유",
  reasonNeeded: "지난 주간 마감(금요일 17:00) 이전에 입력한 실적 날짜를 변경하려면 사유가 필요합니다.",
  save: "저장",
  saving: "저장 중…",
  saved: "저장했습니다.",
  close: "닫기",
  hevnChanges: "HEVN 변경 — 확인해 주세요",
  acknowledge: "확인",
  suggest: "다른 날짜 제안",
  suggestSend: "보내기",
  suggested: "{{d}} 제안함 — HEVN 검토 대기",
  accept: "수락",
  reject: "거절",
  fld_req_exf: "EXF 날짜",
  fld_req_qty: "수량",
  fld_cancelled: "라인 취소",
  history: "이력",
  noHistory: "아직 변경 사항이 없습니다.",
  afterClose: "주간 마감 후 수정",
  noRows: "일치하는 주문이 없습니다.",
  noChanges: "답변을 기다리는 항목이 없습니다.",
  chgWaitVendor: "협력사 확인 대기",
  chgWaitPt: "협력사 제안 {{d}} — PT 결정 필요",
  loading: "불러오는 중…",
  readOnly: "생산 현황을 볼 수 있으며 입력은 PT가 합니다.",
  step_rm_order: "원자재 발주",
  step_rm_arrival: "원자재 입고",
  step_iqc: "IQC",
  step_frame: "프레임",
  step_pps: "PPS",
  step_ppm: "PPM",
  step_cutting: "재단",
  step_print_emb: "프린트/자수",
  step_skin_sewing: "스킨 봉제",
  step_case_sewing: "케이스 봉제",
  step_packing: "포장",
  step_exf: "출고",
  lineCount: "Master {{n}}라인",
  tabSewing: "봉제 계획",
  tourSewT: "봉제 계획",
  tourSewB: "모든 오더의 봉제 라인을 한눈에(라인별), 또는 오더당 한 줄로 Skin과 Case를 나란히(오더별) 봅니다. 라인, 계획·실적 일자, 생산량, 자재 준비일, 착수 지연 사유가 표시됩니다. 행을 클릭하면 오더가 열립니다.",
  sewTitle: "봉제 라인",
  sewHelp: "봉제 라인마다 한 줄입니다. 파트: Skin 또는 Case, 한 번에 봉제하는 품목(예: 백팩)은 Full product. Line #는 라인 목록(자체 라인·외주)에서 고릅니다. 위의 Skin / Case sewing 단계는 이 라인들을 따릅니다.",
  sew_part: "파트",
  sew_lineId: "Line #",
  sew_workers: "작업자",
  sew_planStart: "계획 시작",
  sew_planEnd: "계획 종료",
  sew_actStart: "실제 시작",
  sew_actEnd: "실제 종료",
  sew_lateReason: "착수 지연 사유",
  sew_lateNote: "메모",
  part_skin: "Skin",
  part_case: "Case",
  part_full: "Full product",
  sewAdd: "봉제 라인 추가",
  sewRemove: "이 라인 삭제",
  sewNone: "아직 봉제 라인이 없습니다. 라인마다 한 줄을 추가하고 Skin, Case 또는 Full product를 고르세요.",
  sewReq: "+ 새 라인 또는 외주 요청",
  sewReqPt: "+ 목록에 라인 또는 외주 추가",
  noLineNo: "Line # 없음",
  kind_inhouse: "자체",
  kind_subcon: "외주",
  linePending: "승인 대기",
  lineRejected: "반려",
  lr_material: "자재 지연",
  lr_frame_dac: "프레임 지연 (DAC)",
  lr_labor: "인력 / 캐파",
  lr_hevn_change: "HEVN 변경",
  lr_quality: "품질 문제",
  lr_other: "기타",
  lrPick: "사유 선택",
  sewFromLines: "아래 봉제 라인 기준",
  sewFullStep: "봉제 (Full product)",
  caseNaFull: "N/A — Full product",
  outTitle: "일일 생산량",
  outHelp: "라인별로 매일 생산량을 입력합니다. 한 주를 한 번에 입력해도 됩니다. 합계가 Skin / Case / Full product 생산량이 됩니다. 미래 날짜는 입력할 수 없습니다.",
  outWeek: "주간",
  outAll: "전체",
  outDayTotal: "일 합계",
  outPrev: "‹ 이전 주",
  outThis: "이번 주",
  outNext: "다음 주 ›",
  outCarried: "일일 입력 이전 생산량(Excel PSR 기준): {{v}}. 합계에 더해집니다.",
  outNeedLine: "위에서 봉제 라인을 추가한 뒤 일별 생산량을 입력하세요.",
  warnTitle: "확인해 주세요 (저장은 막지 않습니다):",
  wLateReason: "{{line}}: 계획보다 늦게 착수했거나 아직 착수하지 않았습니다. 착수 지연 사유를 고르세요.",
  wNoLine: "{{part}} 봉제에 일자는 있지만 Line #가 없습니다. Vendor Capacity에 필요합니다.",
  wDupLine: "{{part}} 봉제에 같은 라인이 두 번 있습니다.",
  wOutNoStart: "{{line}}: 생산량은 있는데 실제 시작일이 없습니다.",
  wOutBefore: "{{line}}: {{d}} 생산량이 실제 시작일보다 앞섭니다.",
  edited: "수정됨",
  editedTip: "변경 이력:",
  histOutput: "생산량 {{d}}",
  hist_added: "라인 추가",
  hist_removed: "라인 삭제",
  bulkSew: "봉제 · {{f}}",
  spByLine: "라인별",
  spByOrder: "오더별",
  spLinesOf: "봉제 라인 {{m}}개 중 {{n}}개",
  spOrdersOf: "오더 {{m}}건 중 {{n}}건",
  sp_late: "지연 (협력사)",
  sp_prog: "진행 중",
  sp_planned: "계획됨",
  sp_done: "완료",
  sp_none: "봉제 계획 없음",
  spAfter: "봉제 종료가 EXF 이후",
  spHelpLine: "봉제 라인마다 한 줄입니다. 오더 탭의 협력사·검색·상태가 그대로 적용됩니다. 행을 클릭하면 오더가 열립니다.",
  spHelpOrder: "오더마다 한 줄입니다. 봉제 일자는 가장 이른 라인 기준, 생산량은 모든 라인 합계입니다. 자재 준비 = IQC 합격일(IQC가 N/A면 RM 입고일).",
  spLateStart: "봉제 착수 지연",
  spMissing: "사유 미입력",
  spStatusOn: "상태: {{s}}",
  colMat: "자재 준비",
  colOutput: "생산량",
  colExf: "EXF",
  colStyle: "스타일명",
  colColor: "색상",
  colEstSkin: "봉제 계획 (Skin)",
  colEstCase: "봉제 계획 (Case)",
  colActSkin: "봉제 실적 (Skin)",
  colActCase: "봉제 실적 (Case)",
  colOutSkin: "생산량 (Skin)",
  colOutCase: "생산량 (Case)",
  matPlan: "계획 {{d}}",
  notStarted: "미착수",
  nLines: "{{n}}개 라인",
  missing: "미입력",
  afterExfMark: "› EXF",
  na: "N/A",
  spLineList: "라인 목록",
  linesPendingBanner: "라인 / 외주 요청 {{n}}건이 HEVN PT 승인을 기다립니다.",
  review: "검토",
  llTitle: "라인 목록 — 자체 라인과 외주",
  llHelp: "PT가 관리하는 목록입니다. 협력사가 새로 요청한 항목은 바로 쓸 수 있고, PT가 승인할 때까지 \"승인 대기\"로 표시됩니다. 반려된 항목은 다른 라인으로 옮기기 전까지 오더에 저장할 수 없습니다.",
  llType: "구분",
  llName: "이름",
  llDetails: "상세",
  llStatus: "상태",
  llUsed: "진행 오더",
  llRequested: "요청자",
  ls_approved: "승인",
  ls_pending: "승인 대기",
  ls_rejected: "반려",
  approve: "승인",
  llEmpty: "목록에 라인이 아직 없습니다.",
  llNoPending: "대기 중인 요청이 없습니다.",
  llOnlyPending: "대기 중인 요청만 ({{n}})",
  llAdd: "라인 또는 외주 추가",
  llRequest: "새 라인 또는 외주 요청",
  lrqHelpPt: "{{v}} 목록에 추가되고 바로 승인됩니다.",
  lrqHelpVendor: "HEVN PT가 모든 새 항목을 검토합니다. 바로 사용할 수 있으며, PT 승인 전까지 \"승인 대기\"로 표시됩니다.",
  lrqNamePh: "예: LINE 13 또는 외주처 이름",
  lrqCompany: "회사명",
  lrqAddress: "주소",
  lrqSews: "봉제 품목",
  lrqNoAccount: "외주처는 포털 계정을 받지 않습니다. 진행 상황과 생산량은 협력사가 입력합니다.",
  lrqSend: "요청 보내기",
  lrqAddBtn: "추가",
  lrqSent: "HEVN PT에 요청을 보냈습니다. 지금 바로 사용할 수 있습니다.",
  lrqAdded: "라인 목록에 추가했습니다.",
};
const vi = {
  tourTodoT: "Việc đang chờ bạn",
  tourTodoB: "Các bước đã qua ngày kế hoạch mà chưa có ngày thực tế, các thay đổi của HEVN bạn chưa trả lời, và các ngày EXF bạn chưa xác nhận. Bấm vào để xem đúng các dòng đó.",
  tourFindT: "Tìm dòng của bạn",
  tourFindB: "Tìm theo số đơn, PO, mã hàng hoặc màu, và bấm một trạng thái để chỉ xem các dòng đó. Mỗi tiêu đề cột đều sắp xếp và lọc được như Excel.",
  tourOpenT: "Cập nhật một đơn",
  tourOpenB: "Bấm Mở để xem đơn: xác nhận EXF, điền ngày kế hoạch và ngày thực tế của 12 bước, và xem lịch sử. Ngày thực tế không được là ngày trong tương lai.",
  tourBulkT: "Cập nhật nhiều đơn cùng lúc",
  tourBulkB: "Tick các dòng (hoặc chọn tất cả ở đây) để đặt cùng một ngày kế hoạch, ngày thực tế hoặc N/A cho một bước, hoặc xác nhận EXF yêu cầu cho tất cả.",
  tourExcelT: "Làm trên Excel",
  tourExcelB: "Tải các dòng đang hiện về, điền ngày trong Excel (dd/Mon/yyyy, ví dụ 05/Nov/2026) rồi tải file lên. Bạn sẽ thấy những gì thay đổi trước khi lưu; ô trống không thay đổi gì.",
  tourCalT: "Lịch xuất hàng",
  tourCalB: "Kế hoạch xuất hàng theo tháng: mỗi đơn nằm ở EXF yêu cầu (hoặc EXF xác nhận). Chọn vendor và nước có ngày lễ, đổi nhãn giữa theo trạng thái và theo vendor, bấm vào ngày, nhãn hoặc số tuần để xem danh sách đơn. \"!\" = đã qua ngày mà chưa xuất.",
  tourChangesT: "Thay đổi từ HEVN",
  tourChangesB: "Khi HEVN đổi ngày EXF hoặc số lượng, thay đổi sẽ chờ ở đây: xác nhận đã biết, hoặc đề xuất ngày khác để HEVN duyệt.",
  tourSyncT: "Đồng bộ từ Master",
  tourSyncB: "Các dòng lấy từ Master Sheet sau mỗi lần làm mới sổ (05:30 và 13:30). Bấm đồng bộ để đọc ngay; mất khoảng một phút.",
  tabCal: "Lịch xuất hàng",
  calPrev: "Tháng trước",
  calNext: "Tháng sau",
  calBasis: "Ngày căn cứ",
  calBasis_req: "EXF yêu cầu",
  calBasis_cfm: "EXF xác nhận",
  calView: "Nhãn",
  calViewStatus: "Tất cả · theo trạng thái",
  calViewVendor: "Theo vendor",
  calVendors: "Vendor",
  calAll: "Tất cả",
  calNone: "Bỏ chọn",
  calHolidays: "Ngày lễ",
  calS_late: "Trễ",
  calS_noactual: "Chưa có thực tế",
  calS_noinput: "Chưa nhập",
  calS_ontrack: "Đúng tiến độ",
  calS_shipped: "Đã xuất",
  calMonthSum: "{{n}} đơn · {{qty}} pcs trong tháng",
  calMore: "{{n}} mục nữa",
  calLate: "{{n}} trễ",
  calPastMark: "Đã qua ngày mà chưa xuất",
  calPastBtn: "Quá EXF, chưa xuất ({{n}})",
  calListDay: "{{d}} — {{n}} đơn, {{qty}} pcs",
  calListWeek: "Tuần {{w}} — {{n}} đơn, {{qty}} pcs",
  calListPast: "Quá ngày EXF mà chưa xuất — {{n}} đơn, {{qty}} pcs",
  calEmpty: "Không có đơn nào.",
  calWeek: "Tuần {{w}}",
  calFallback: "Dòng chưa có EXF xác nhận sẽ nằm ở EXF yêu cầu.",
  calHolidayFail: "Hiện chưa đọc được ngày lễ {{c}} từ Google.",
  calCountry_VN: "Việt Nam",
  calCountry_KR: "Hàn Quốc",
  calCountry_US: "Mỹ",
  calCountry_NL: "Hà Lan",
  calCountry_SG: "Singapore",
  calCountry_JP: "Nhật Bản",
  xlDown: "Tải Excel",
  xlUp: "Tải lên Excel",
  xlReading: "Đang đọc file…",
  xlPreview: "File sẽ thay đổi gì",
  xlSummary: "{{ok}} dòng sẽ thay đổi, {{failed}} dòng có lỗi, {{unchanged}} dòng không đổi. Ô trống không thay đổi gì.",
  xlApply: "Áp dụng thay đổi",
  xlApplied: "Đã cập nhật {{ok}} dòng từ file, {{failed}} dòng chưa.",
  xlRow: "Dòng",
  xlRowId: "Row ID",
  nav: "Tình trạng sản xuất",
  title: "Tình trạng sản xuất",
  sub: "Các dòng lấy từ Master Sheet; vendor cập nhật tiến độ, HEVN xem mọi vendor. Không hiển thị giá ở đây.",
  subVendor: "Các đơn đang mở của bạn từ Helinox. Cập nhật tiến độ tại đây — không cần gửi file Excel nữa.",
  vendor: "Vendor",
  allVendors: "Tất cả vendor",
  sync: "Đồng bộ từ Master",
  syncing: "Đang đồng bộ… (khoảng 1 phút)",
  lastSync: "Đồng bộ lần cuối {{when}}",
  synced: "Đã đồng bộ: {{created}} dòng mới, {{changed}} thay đổi từ HEVN, {{closed}} đóng.",
  tabRows: "Đơn hàng",
  tabChanges: "Thay đổi",
  todoTitle: "Việc cần làm tuần này",
  todoActual: "Thiếu {{n}} ngày thực tế",
  todoChanges: "{{n}} thay đổi từ HEVN cần xác nhận",
  todoCfm: "{{n}} đơn chưa có Confirmed EXF",
  search: "Tìm đơn, PO, mặt hàng, màu…",
  clearFilters: "Xóa lọc",
  shownOf: "{{n}} / {{m}}",
  colStatus: "Trạng thái",
  colLot: "Đơn",
  colItem: "Mặt hàng",
  colQty: "SL",
  colReq: "EXF yêu cầu",
  colCfm: "EXF xác nhận",
  colProgress: "Tiến độ",
  colNext: "Bước tiếp theo",
  colUpdated: "Cập nhật",
  colVendor: "Vendor",
  colAction: "Thao tác",
  open: "Mở",
  st_on_track: "Đúng tiến độ",
  st_late_vendor: "Trễ · Vendor",
  st_late_dac: "Trễ · DAC (frame)",
  st_actual_missing: "Thiếu ngày thực tế",
  st_no_input: "Chưa nhập",
  st_shipped: "Đã xuất",
  st_closed: "Đã đóng",
  st_cancelled: "Đã hủy",
  all: "Tất cả",
  changedOnly: "HEVN đã thay đổi",
  selected: "Đã chọn {{n}}",
  bulkStep: "Bước",
  bulkWhat: "Đặt",
  bulkActual: "Ngày thực tế",
  bulkPlan: "Ngày kế hoạch",
  bulkNa: "Không áp dụng",
  bulkCfmReq: "EXF xác nhận = EXF yêu cầu",
  today: "Hôm nay",
  apply: "Áp dụng cho dòng đã chọn",
  bulkDone: "Đã cập nhật {{ok}}, chưa cập nhật {{failed}}.",
  lines: "Các dòng Master",
  linePo: "HNX PO",
  lineCustomerPo: "Customer PO",
  lineDest: "Điểm đến",
  cfmExf: "EXF xác nhận",
  cfmSame: "Giống EXF yêu cầu",
  cfmNotYet: "chưa xác nhận",
  yourOrderNo: "Số đơn của bạn",
  remark: "Ghi chú",
  steps: "Các bước tiến độ",
  stepPlan: "Kế hoạch",
  stepActual: "Thực tế",
  stepStatus: "Trạng thái",
  stepCoRef: "Mã C/O",
  ss_planned: "Kế hoạch",
  ss_done: "Xong",
  ss_na: "Không áp dụng",
  ss_co: "C/O (đã làm theo đơn trước)",
  frameDac: "Frame do DAC phụ trách — HEVN cập nhật.",
  reason: "Lý do",
  reasonNeeded: "Sửa ngày thực tế đã nhập trước lần chốt tuần (thứ 6 17:00) cần ghi lý do.",
  save: "Lưu",
  saving: "Đang lưu…",
  saved: "Đã lưu.",
  close: "Đóng",
  hevnChanges: "HEVN đã thay đổi — vui lòng xác nhận",
  acknowledge: "Xác nhận",
  suggest: "Đề xuất ngày khác",
  suggestSend: "Gửi",
  suggested: "Bạn đã đề xuất {{d}} — chờ HEVN",
  accept: "Chấp nhận",
  reject: "Từ chối",
  fld_req_exf: "Ngày EXF",
  fld_req_qty: "Số lượng",
  fld_cancelled: "Dòng bị hủy",
  history: "Lịch sử",
  noHistory: "Chưa có thay đổi.",
  afterClose: "sửa sau khi chốt tuần",
  noRows: "Không có đơn phù hợp.",
  noChanges: "Không có việc nào chờ xử lý.",
  chgWaitVendor: "chờ vendor",
  chgWaitPt: "vendor đề xuất {{d}} — PT quyết",
  loading: "Đang tải…",
  readOnly: "Bạn chỉ xem được; PT cập nhật.",
  step_rm_order: "Đặt NVL",
  step_rm_arrival: "NVL về",
  step_iqc: "IQC",
  step_frame: "Frame",
  step_pps: "PPS",
  step_ppm: "PPM",
  step_cutting: "Cắt",
  step_print_emb: "In/Thêu",
  step_skin_sewing: "May skin",
  step_case_sewing: "May case",
  step_packing: "Đóng gói",
  step_exf: "Xuất xưởng",
  lineCount: "{{n}} dòng Master",
  tabSewing: "Kế hoạch may",
  tourSewT: "Kế hoạch may",
  tourSewB: "Mọi chuyền may trên các đơn hàng (Theo chuyền), hoặc mỗi đơn một dòng với Skin và Case cạnh nhau (Theo đơn): chuyền, ngày kế hoạch và thực tế, sản lượng, ngày vật tư sẵn sàng và lý do bắt đầu trễ. Bấm vào một dòng để mở đơn.",
  sewTitle: "Chuyền may",
  sewHelp: "Mỗi chuyền may một dòng. Phần: Skin hoặc Case, hoặc Full product khi sản phẩm được may liền một khối (ví dụ ba lô). Line # chọn từ danh sách chuyền (chuyền nội bộ và Subcon). Các bước Skin / Case sewing ở trên đi theo các chuyền này.",
  sew_part: "Phần",
  sew_lineId: "Line #",
  sew_workers: "Công nhân",
  sew_planStart: "Bắt đầu (KH)",
  sew_planEnd: "Kết thúc (KH)",
  sew_actStart: "Bắt đầu thực tế",
  sew_actEnd: "Kết thúc thực tế",
  sew_lateReason: "Lý do bắt đầu trễ",
  sew_lateNote: "Ghi chú",
  part_skin: "Skin",
  part_case: "Case",
  part_full: "Full product",
  sewAdd: "Thêm chuyền may",
  sewRemove: "Bỏ chuyền này",
  sewNone: "Chưa có chuyền may. Thêm mỗi chuyền một dòng và chọn Skin, Case hoặc Full product.",
  sewReq: "+ Đề nghị thêm chuyền hoặc subcon",
  sewReqPt: "+ Thêm chuyền hoặc subcon vào danh sách",
  noLineNo: "chưa có line #",
  kind_inhouse: "Nội bộ",
  kind_subcon: "Subcon",
  linePending: "chờ duyệt",
  lineRejected: "bị từ chối",
  lr_material: "Vật tư về trễ",
  lr_frame_dac: "Khung về trễ (DAC)",
  lr_labor: "Nhân lực / năng lực",
  lr_hevn_change: "HEVN thay đổi",
  lr_quality: "Vấn đề chất lượng",
  lr_other: "Khác",
  lrPick: "Chọn lý do",
  sewFromLines: "Theo các chuyền may bên dưới",
  sewFullStep: "May (Full product)",
  caseNaFull: "N/A — Full product",
  outTitle: "Sản lượng hằng ngày",
  outHelp: "Nhập sản lượng mỗi ngày cho từng chuyền; nhập cả tuần một lần cũng được. Tổng cộng sẽ thành sản lượng Skin / Case / Full product. Không nhập được ngày trong tương lai.",
  outWeek: "Tuần",
  outAll: "Tất cả",
  outDayTotal: "Tổng ngày",
  outPrev: "‹ Tuần trước",
  outThis: "Tuần này",
  outNext: "Tuần sau ›",
  outCarried: "Sản lượng trước khi theo dõi hằng ngày (từ file PSR Excel): {{v}}. Được cộng vào tổng.",
  outNeedLine: "Thêm một chuyền may ở trên, rồi nhập sản lượng theo ngày.",
  warnTitle: "Vui lòng kiểm tra (vẫn lưu được):",
  wLateReason: "{{line}}: bắt đầu may trễ hơn kế hoạch, hoặc chưa bắt đầu. Hãy chọn lý do bắt đầu trễ.",
  wNoLine: "{{part}}: có ngày may nhưng chưa có line #. Vendor Capacity cần thông tin này.",
  wDupLine: "{{part}}: cùng một chuyền được ghi hai lần.",
  wOutNoStart: "{{line}}: đã có sản lượng nhưng chưa có ngày bắt đầu thực tế.",
  wOutBefore: "{{line}}: sản lượng ngày {{d}} có trước ngày bắt đầu thực tế.",
  edited: "đã sửa",
  editedTip: "Đã thay đổi:",
  histOutput: "sản lượng {{d}}",
  hist_added: "thêm chuyền",
  hist_removed: "bỏ chuyền",
  bulkSew: "May · {{f}}",
  spByLine: "Theo chuyền",
  spByOrder: "Theo đơn",
  spLinesOf: "{{n}} / {{m}} chuyền may",
  spOrdersOf: "{{n}} / {{m}} đơn",
  sp_late: "Trễ (vendor)",
  sp_prog: "Đang may",
  sp_planned: "Đã lên kế hoạch",
  sp_done: "Xong",
  sp_none: "Chưa có kế hoạch may",
  spAfter: "May xong sau EXF",
  spHelpLine: "Mỗi chuyền may một dòng. Vendor, ô tìm kiếm và trạng thái ở tab Đơn hàng cũng áp dụng ở đây. Bấm vào một dòng để mở đơn.",
  spHelpOrder: "Mỗi đơn một dòng. Ngày may lấy theo chuyền sớm nhất; sản lượng là tổng mọi chuyền. Vật tư sẵn sàng = ngày đạt IQC (ngày RM về khi IQC là N/A).",
  spLateStart: "Bắt đầu may trễ",
  spMissing: "Thiếu lý do",
  spStatusOn: "Trạng thái: {{s}}",
  colMat: "Vật tư sẵn sàng",
  colOutput: "Sản lượng",
  colExf: "EXF",
  colStyle: "Tên mẫu",
  colColor: "Màu",
  colEstSkin: "May dự kiến (Skin)",
  colEstCase: "May dự kiến (Case)",
  colActSkin: "May thực tế (Skin)",
  colActCase: "May thực tế (Case)",
  colOutSkin: "Sản lượng (Skin)",
  colOutCase: "Sản lượng (Case)",
  matPlan: "KH {{d}}",
  notStarted: "chưa bắt đầu",
  nLines: "{{n}} chuyền",
  missing: "Thiếu",
  afterExfMark: "› EXF",
  na: "N/A",
  spLineList: "Danh sách chuyền",
  linesPendingBanner: "{{n}} đề nghị chuyền / subcon đang chờ HEVN PT.",
  review: "Xem",
  llTitle: "Danh sách chuyền — chuyền nội bộ và subcon",
  llHelp: "PT quản lý danh sách này. Mục mới do vendor đề nghị dùng được ngay và hiện \"chờ duyệt\" tới khi PT duyệt. Mục bị từ chối không lưu được vào đơn cho tới khi đơn chuyển sang chuyền khác.",
  llType: "Loại",
  llName: "Tên",
  llDetails: "Chi tiết",
  llStatus: "Trạng thái",
  llUsed: "Đơn đang mở",
  llRequested: "Người đề nghị",
  ls_approved: "Đã duyệt",
  ls_pending: "Chờ duyệt",
  ls_rejected: "Từ chối",
  approve: "Duyệt",
  llEmpty: "Danh sách chưa có chuyền nào.",
  llNoPending: "Không có đề nghị nào đang chờ.",
  llOnlyPending: "Chỉ đề nghị đang chờ ({{n}})",
  llAdd: "Thêm chuyền hoặc subcon",
  llRequest: "Đề nghị thêm chuyền hoặc subcon",
  lrqHelpPt: "Thêm vào danh sách của {{v}} và duyệt luôn.",
  lrqHelpVendor: "HEVN PT xem xét mọi mục mới. Bạn dùng được ngay; mục này hiện \"chờ duyệt\" tới khi PT duyệt.",
  lrqNamePh: "vd. LINE 13, hoặc tên subcon",
  lrqCompany: "Tên công ty",
  lrqAddress: "Địa chỉ",
  lrqSews: "May những gì",
  lrqNoAccount: "Subcon không có tài khoản Portal. Bạn nhập tiến độ và sản lượng thay cho họ.",
  lrqSend: "Gửi đề nghị",
  lrqAddBtn: "Thêm",
  lrqSent: "Đã gửi đề nghị tới HEVN PT. Bạn dùng được ngay.",
  lrqAdded: "Đã thêm vào danh sách chuyền.",
};
const zh = {
  tourTodoT: "待您处理",
  tourTodoB: "计划日期已过但没有实际日期的步骤、尚未回复的 HEVN 变更，以及尚未确认的 EXF 日期。点击即可只看这些行。",
  tourFindT: "查找您的行",
  tourFindB: "按订单号、PO、品号或颜色搜索，点击某个状态即可只看这些行。每个列标题都可像 Excel 一样排序和筛选。",
  tourOpenT: "更新一个订单",
  tourOpenB: "点击打开查看订单：确认 EXF，填写 12 个步骤的计划日期和实际日期，并查看历史。实际日期不能是未来日期。",
  tourBulkT: "批量更新",
  tourBulkB: "勾选多行（或在此全选），为同一步骤设置相同的计划日期、实际日期或 N/A，或把它们的要求 EXF 设为确认 EXF。",
  tourExcelT: "在 Excel 中处理",
  tourExcelB: "下载屏幕上的行，在 Excel 中填写日期（dd/Mon/yyyy，例如 05/Nov/2026）后上传。保存前会先显示将变更的内容；空白单元格不做任何更改。",
  tourCalT: "出货日历",
  tourCalB: "按月查看出货计划：每个订单显示在要求 EXF（或确认 EXF）当天。勾选供应商和节假日国家，在按状态与按供应商之间切换标签，点击日期、标签或周数即可列出订单。\"!\" = 日期已过但未出货。",
  tourChangesT: "HEVN 变更",
  tourChangesB: "HEVN 更改 EXF 日期或数量时会显示在这里：确认已知悉，或建议另一个日期由 HEVN 决定。",
  tourSyncT: "从 Master 同步",
  tourSyncB: "每次台账刷新后（05:30 和 13:30）从 Master Sheet 读取行。点击同步立即读取，约需一分钟。",
  tabCal: "出货日历",
  calPrev: "上个月",
  calNext: "下个月",
  calBasis: "日期依据",
  calBasis_req: "要求 EXF",
  calBasis_cfm: "确认 EXF",
  calView: "标签",
  calViewStatus: "全部 · 按状态",
  calViewVendor: "按供应商",
  calVendors: "供应商",
  calAll: "全选",
  calNone: "全不选",
  calHolidays: "节假日",
  calS_late: "延迟",
  calS_noactual: "无实际",
  calS_noinput: "未填写",
  calS_ontrack: "正常",
  calS_shipped: "已出货",
  calMonthSum: "本月 {{n}} 单 · {{qty}} pcs",
  calMore: "还有 {{n}} 项",
  calLate: "{{n}} 延迟",
  calPastMark: "日期已过但未出货",
  calPastBtn: "EXF 已过、未出货（{{n}}）",
  calListDay: "{{d}} — {{n}} 单，{{qty}} pcs",
  calListWeek: "第 {{w}} 周 — {{n}} 单，{{qty}} pcs",
  calListPast: "EXF 日期已过且未出货 — {{n}} 单，{{qty}} pcs",
  calEmpty: "没有订单。",
  calWeek: "第 {{w}} 周",
  calFallback: "没有确认 EXF 的行按要求 EXF 显示。",
  calHolidayFail: "暂时无法从 Google 读取 {{c}} 的节假日。",
  calCountry_VN: "越南",
  calCountry_KR: "韩国",
  calCountry_US: "美国",
  calCountry_NL: "荷兰",
  calCountry_SG: "新加坡",
  calCountry_JP: "日本",
  xlDown: "下载 Excel",
  xlUp: "上传 Excel",
  xlReading: "正在读取文件…",
  xlPreview: "文件将变更的内容",
  xlSummary: "{{ok}} 行将变更，{{failed}} 行有问题，{{unchanged}} 行无变化。空白单元格不做任何更改。",
  xlApply: "应用变更",
  xlApplied: "已从文件更新 {{ok}} 行，{{failed}} 行未更新。",
  xlRow: "行",
  xlRowId: "Row ID",
  nav: "生产状态",
  title: "生产状态",
  sub: "行来自 Master Sheet；供应商更新进度，HEVN 查看所有供应商。此处从不显示价格。",
  subVendor: "来自 Helinox 的进行中订单。请在此更新进度，不再需要 Excel 文件。",
  vendor: "供应商",
  allVendors: "全部供应商",
  sync: "从 Master 同步",
  syncing: "同步中…（约 1 分钟）",
  lastSync: "上次同步 {{when}}",
  synced: "已同步：新增 {{created}} 行，HEVN 变更 {{changed}} 条，关闭 {{closed}} 条。",
  tabRows: "订单",
  tabChanges: "变更",
  todoTitle: "本周待办",
  todoActual: "缺少 {{n}} 个实际日期",
  todoChanges: "{{n}} 条 HEVN 变更待确认",
  todoCfm: "{{n}} 个订单未填确认 EXF",
  search: "搜索订单、PO、品名、颜色…",
  clearFilters: "清除筛选",
  shownOf: "{{n}} / {{m}}",
  colStatus: "状态",
  colLot: "订单",
  colItem: "品名",
  colQty: "数量",
  colReq: "要求 EXF",
  colCfm: "确认 EXF",
  colProgress: "进度",
  colNext: "下一步",
  colUpdated: "更新",
  colVendor: "供应商",
  colAction: "操作",
  open: "打开",
  st_on_track: "正常",
  st_late_vendor: "延迟 · 供应商",
  st_late_dac: "延迟 · DAC（框架）",
  st_actual_missing: "缺少实际日期",
  st_no_input: "未输入",
  st_shipped: "已出货",
  st_closed: "已关闭",
  st_cancelled: "已取消",
  all: "全部",
  changedOnly: "HEVN 已变更",
  selected: "已选 {{n}}",
  bulkStep: "步骤",
  bulkWhat: "设置",
  bulkActual: "实际日期",
  bulkPlan: "计划日期",
  bulkNa: "不适用",
  bulkCfmReq: "确认 EXF = 要求 EXF",
  today: "今天",
  apply: "应用到所选",
  bulkDone: "已更新 {{ok}} 条，未更新 {{failed}} 条。",
  lines: "Master 行",
  linePo: "HNX PO",
  lineCustomerPo: "客户 PO",
  lineDest: "目的地",
  cfmExf: "确认 EXF",
  cfmSame: "与要求相同",
  cfmNotYet: "尚未确认",
  yourOrderNo: "贵方订单号",
  remark: "备注",
  steps: "进度步骤",
  stepPlan: "计划",
  stepActual: "实际",
  stepStatus: "状态",
  stepCoRef: "C/O 参考",
  ss_planned: "计划",
  ss_done: "完成",
  ss_na: "不适用",
  ss_co: "C/O（在之前订单中完成）",
  frameDac: "框架由 DAC 负责，HEVN 更新。",
  reason: "原因",
  reasonNeeded: "修改上次周结（周五 17:00）之前输入的实际日期需要填写原因。",
  save: "保存",
  saving: "保存中…",
  saved: "已保存。",
  close: "关闭",
  hevnChanges: "HEVN 已变更 — 请确认",
  acknowledge: "确认",
  suggest: "建议其他日期",
  suggestSend: "发送",
  suggested: "您建议了 {{d}} — 等待 HEVN",
  accept: "接受",
  reject: "拒绝",
  fld_req_exf: "EXF 日期",
  fld_req_qty: "数量",
  fld_cancelled: "行已取消",
  history: "历史",
  noHistory: "尚无变更。",
  afterClose: "周结后修改",
  noRows: "没有匹配的订单。",
  noChanges: "没有待处理的事项。",
  chgWaitVendor: "等待供应商",
  chgWaitPt: "供应商建议 {{d}} — 待 PT 决定",
  loading: "加载中…",
  readOnly: "您可以查看生产状态，由 PT 更新。",
  step_rm_order: "原料下单",
  step_rm_arrival: "原料到货",
  step_iqc: "IQC",
  step_frame: "框架",
  step_pps: "PPS",
  step_ppm: "PPM",
  step_cutting: "裁剪",
  step_print_emb: "印刷/刺绣",
  step_skin_sewing: "面料缝制",
  step_case_sewing: "收纳袋缝制",
  step_packing: "包装",
  step_exf: "出厂",
  lineCount: "{{n}} 条 Master 行",
  tabSewing: "缝制计划",
  tourSewT: "缝制计划",
  tourSewB: "查看所有订单的每条缝制线（按产线），或每个订单一行、Skin 与 Case 并列（按订单）：产线、计划与实际日期、产量、物料齐备日和延迟开工原因。点击一行即可打开订单。",
  sewTitle: "缝制线",
  sewHelp: "每条缝制线一行。部件：Skin 或 Case；整件一次缝制的产品（如背包）选 Full product。Line # 从产线清单（自有产线和外包）中选择。上方的 Skin / Case sewing 步骤跟随这些产线。",
  sew_part: "部件",
  sew_lineId: "Line #",
  sew_workers: "工人数",
  sew_planStart: "计划开始",
  sew_planEnd: "计划结束",
  sew_actStart: "实际开始",
  sew_actEnd: "实际结束",
  sew_lateReason: "延迟开工原因",
  sew_lateNote: "备注",
  part_skin: "Skin",
  part_case: "Case",
  part_full: "Full product",
  sewAdd: "添加缝制线",
  sewRemove: "删除此产线",
  sewNone: "尚无缝制线。每条产线添加一行，并选择 Skin、Case 或 Full product。",
  sewReq: "+ 申请新产线或外包",
  sewReqPt: "+ 向清单添加产线或外包",
  noLineNo: "无 Line #",
  kind_inhouse: "自有",
  kind_subcon: "外包",
  linePending: "待审批",
  lineRejected: "已驳回",
  lr_material: "物料延迟",
  lr_frame_dac: "框架延迟 (DAC)",
  lr_labor: "人力 / 产能",
  lr_hevn_change: "HEVN 变更",
  lr_quality: "质量问题",
  lr_other: "其他",
  lrPick: "选择原因",
  sewFromLines: "取自下方缝制线",
  sewFullStep: "缝制 (Full product)",
  caseNaFull: "N/A — Full product",
  outTitle: "每日产量",
  outHelp: "按产线填写每天的产量；一次填整周也可以。合计即为 Skin / Case / Full product 产量。不能填写未来日期。",
  outWeek: "本周合计",
  outAll: "全部",
  outDayTotal: "当日合计",
  outPrev: "‹ 上一周",
  outThis: "本周",
  outNext: "下一周 ›",
  outCarried: "开始按日记录之前的产量（来自 Excel PSR）：{{v}}。已计入合计。",
  outNeedLine: "请先在上方添加缝制线，再按天填写产量。",
  warnTitle: "请检查（不影响保存）：",
  wLateReason: "{{line}}：开工晚于计划或尚未开工。请选择延迟开工原因。",
  wNoLine: "{{part}} 缝制有日期但没有 Line #。Vendor Capacity 需要它。",
  wDupLine: "{{part}} 缝制中同一产线出现了两次。",
  wOutNoStart: "{{line}}：已填产量，但没有实际开始日期。",
  wOutBefore: "{{line}}：{{d}} 的产量早于实际开始日期。",
  edited: "已修改",
  editedTip: "修改记录：",
  histOutput: "产量 {{d}}",
  hist_added: "添加产线",
  hist_removed: "删除产线",
  bulkSew: "缝制 · {{f}}",
  spByLine: "按产线",
  spByOrder: "按订单",
  spLinesOf: "{{m}} 条缝制线中的 {{n}} 条",
  spOrdersOf: "{{m}} 个订单中的 {{n}} 个",
  sp_late: "延迟（供应商）",
  sp_prog: "进行中",
  sp_planned: "已计划",
  sp_done: "完成",
  sp_none: "无缝制计划",
  spAfter: "缝制结束晚于 EXF",
  spHelpLine: "每条缝制线一行。订单页的供应商、搜索和状态同样适用。点击一行即可打开订单。",
  spHelpOrder: "每个订单一行。缝制日期取最早的产线；产量为所有产线合计。物料齐备 = IQC 合格日（IQC 为 N/A 时取 RM 到货日）。",
  spLateStart: "延迟开工",
  spMissing: "缺少原因",
  spStatusOn: "状态：{{s}}",
  colMat: "物料齐备",
  colOutput: "产量",
  colExf: "EXF",
  colStyle: "款式名称",
  colColor: "颜色",
  colEstSkin: "计划缝制 (Skin)",
  colEstCase: "计划缝制 (Case)",
  colActSkin: "实际缝制 (Skin)",
  colActCase: "实际缝制 (Case)",
  colOutSkin: "产量 (Skin)",
  colOutCase: "产量 (Case)",
  matPlan: "计划 {{d}}",
  notStarted: "未开工",
  nLines: "{{n}} 条产线",
  missing: "缺少",
  afterExfMark: "› EXF",
  na: "N/A",
  spLineList: "产线清单",
  linesPendingBanner: "{{n}} 个产线 / 外包申请等待 HEVN PT 审批。",
  review: "审核",
  llTitle: "产线清单 — 自有产线和外包",
  llHelp: "此清单由 PT 维护。供应商新申请的条目可立即使用，在 PT 审批前显示\"待审批\"。被驳回的条目在订单换到其他产线之前不能保存到订单上。",
  llType: "类型",
  llName: "名称",
  llDetails: "详情",
  llStatus: "状态",
  llUsed: "未结订单",
  llRequested: "申请人",
  ls_approved: "已批准",
  ls_pending: "待审批",
  ls_rejected: "已驳回",
  approve: "批准",
  llEmpty: "清单中尚无产线。",
  llNoPending: "没有待处理的申请。",
  llOnlyPending: "仅看待处理申请（{{n}}）",
  llAdd: "添加产线或外包",
  llRequest: "申请新产线或外包",
  lrqHelpPt: "添加到 {{v}} 的清单并立即批准。",
  lrqHelpVendor: "HEVN PT 会审核每个新条目。可立即使用；在 PT 批准前显示\"待审批\"。",
  lrqNamePh: "例如 LINE 13，或外包厂名称",
  lrqCompany: "公司名称",
  lrqAddress: "地址",
  lrqSews: "缝制内容",
  lrqNoAccount: "外包厂不会获得 Portal 账号，由您代为填写其进度和产量。",
  lrqSend: "发送申请",
  lrqAddBtn: "添加",
  lrqSent: "已向 HEVN PT 发送申请，现在即可使用。",
  lrqAdded: "已添加到产线清单。",
};
const dictionary = { ns: 'xPsr', en, ko, vi, zh };
export default dictionary;
